<template>
  <ul class="infopopup-container p-inline-start-0">
    <li v-for="(infoPopup, index) in getInfoPopups()" :key="index">
      <div class="infopopup info-general" role="alert" :class="getClass(infoPopup)">
        <div class="info-date"><small>{{ dateFormatted(infoPopup) }}</small></div>
        <div class="info-title">{{ infoPopup.title }}</div>
        <div class="info-desc" v-if="infoPopup.description">{{ infoPopup.description }}</div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { InfoPopupData } from '@/models/InfoPopupData'
import { formatDateTime } from '@/utils/formatUtils';
import { now } from '@/utils/dateTimeUtils';

export default defineComponent({
  name: 'InfoPopup',
  data: () => {
    return {
      now: now(),
      intervalId: null as number|null
    }
  },
  methods: {
    getInfoPopups(): InfoPopupData[] {
      const expiration = this.now.minus({
        seconds: 10
      })
      return this.$store.state.infoPopupData.filter(infoPopupData => expiration < infoPopupData.date)
    },
    dateFormatted(infoPopup: InfoPopupData): string {
      return formatDateTime(infoPopup.date)
    },
    getClass(infoPopup: InfoPopupData): string {
      return 'info-' + infoPopup.type
    }
  },
  created() {
    this.intervalId = setInterval(() => {
      this.now = now()
    }, 1000)
  },
});
</script>
